import React from 'react';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import PropTypes from 'prop-types';
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    withStyles,
} from 'material-ui';
import {builderStyles} from '../style/builder';

const PlaceholderPopup = ({
    onPlaceholderChange,
    classes,
    open,
    placeholder,
    onHandleSubmit,
    onHandleClose,
}) => {
    return (
        <EditDialog
            open={open}
            classes={{
                paper: classes.paperDialog,
                fullWidth: classes.fullWidth,
            }}
        >
            <DialogTitle>Edit Placeholder</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="placeholder"
                    label="Placeholder"
                    onChange={(event) => {
                        onPlaceholderChange(event.target.value);
                    }}
                    fullWidth
                    value={placeholder}
                />
            </DialogContent>
            <DialogActions className={classes.dialogActionsBtn}>
                <Button variant="raised" onClick={(ev) => onHandleClose(ev)}>
                    Cancel
                </Button>
                <Button
                    variant="raised"
                    onClick={(ev) => onHandleSubmit(ev)}
                    color="primary"
                >
                    Done
                </Button>
            </DialogActions>
        </EditDialog>
    );
};

PlaceholderPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    onPlaceholderChange: PropTypes.func.isRequired,
    onHandleClose: PropTypes.func.isRequired,
    onHandleSubmit: PropTypes.func.isRequired,
};

export default withStyles(builderStyles)(PlaceholderPopup);



// WEBPACK FOOTER //
// ./src/containers/templates/builder/form/PlaceholderPopup.jsx